import { makeStyles } from '@material-ui/core/styles';
import { convertPxToRem } from '../../common/utils/helpers/GenericHelpers';

export const useStyles = makeStyles((theme) => ({
    wrapper: {
        '& p': {
            fontSize: convertPxToRem(16),
            marginBottom: `${convertPxToRem(16)} !important`,
        },
        '& p:first-child': {
            fontSize: convertPxToRem(20),
        },
        '& h2': {
            padding: '35px 0 15px 0',
            fontSize: convertPxToRem(20),
            margin: 0,
        },
        '& h5': {
            fontSize: convertPxToRem(16),
            paddingTop: 20,
            margin: 0,
        },
        '& h3': {
            fontSize: convertPxToRem(20),
            padding: '20px 0 20px 0',
            fontWeight: 400,
            margin: 0,
        },
        '& ul': {
            margin: '0 0 0 18px',
            padding: 0,
            '& li': {
                fontSize: convertPxToRem(16),
                color: theme.palette.text.primary,
                fontWeight: 300,
                lineHeight: '20px',
            },
        },
    },
    insuranceBox: {
        '& h4': {
            marginBottom: convertPxToRem(5),
        },
        '& p': {
            fontSize: convertPxToRem(14),
            marginBottom: '0 !important',
            color: '#6785A6', //'#53759b'
        },
    },
    footer: {
        '& h5': {
            fontSize: convertPxToRem(16),
            paddingTop: 40,
            margin: 0,
        },
    },
}));
